import React from 'react';
import { IconProps } from '.';

const SvgDocument = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M7 7.75h10v-1.5H7v1.5ZM17 11.75H7v-1.5h10v1.5ZM7 15.75h3v-1.5H7v1.5Z' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M14.25 22 21 15.333V2H3v20h11.25ZM4.5 20.5v-17h15v10.75h-6.25v6.25H4.5Zm10.25-4.75h3.694l-3.694 3.648V15.75Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgDocument;
